<template>
	<div>
		<div class="page-body">
			<div class="_tip" v-if="tipShow">适用于同城、社区、物业、小店、写字楼等团购<i class="el-icon-close tip_close" @click="close_tip"></i></div>
			<div class="btn-box">
				<el-button type="primary" @click="gopublish()">+本地团购</el-button>
			</div>
			
			<div style="height: 2px;background: #DCDFE6;;"></div>
			
			<div :style="!(list.length==0 && !loading) ? 'min-height: 480px' : ''" >
				<el-table class="my-table" v-loading="loading" :data="list" :row-class-name="tableRowClassName">
					<el-table-column label="团购名称" align="left" min-width="80">
						<template slot-scope="scope">
							<div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{{scope.row.title}}</div>
						</template>
					</el-table-column>
					<el-table-column label="商品" align="center" min-width="110">
						<template slot-scope="scope">
							<el-button type="text" size="medium" @click="showProduct(scope.row.index)">
								共{{scope.row.pcount}}个>
							</el-button>
						</template>
					</el-table-column>
					<el-table-column label="团购周期" align="center">
						<template slot-scope="scope">
							{{scope.row.cycle}}天
						</template>
					</el-table-column>
					<el-table-column label="创建时间" align="center">
						<template slot-scope="scope">
							{{scope.row.create_time}}
						</template>
					</el-table-column>
					<el-table-column label="状态" align="center">
						<template slot-scope="scope">
							{{scope.row.status_txt}}
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" min-width="150">
						<template slot-scope="scope">
							<el-button type="text" size="medium" @click="edit(scope.row.index)" v-if="scope.row.btn_status == 0">
								编辑
							</el-button>
							<el-button type="text" size="medium" @click="close(scope.row.index)" v-if="scope.row.btn_status == 1">
								结束
							</el-button>
							<el-button type="text" size="medium" @click="del(scope.row.index)">
								删除
							</el-button>
							<el-button type="text" size="medium" @click="godata(scope.row.index)" v-if="scope.row.btn_status != 0">
								查看数据
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<template v-if="count > 0">
				<el-pagination class="my-pagination" background align="center" layout="total, prev, pager, next, jumper" :current-page="currentPage" :total="count" :page-size="pageSize" @current-change="handleCurrentChange">
				</el-pagination>
			</template>
		</div>
		
		
		<dialog-delete :show="showDialogDetele" :event_id="event_id" @close="closeDialogDetele" @success="dialogDeteleSuccess"></dialog-delete>
		<dialog-close :show="showDialogClose" :event_id="event_id" @close="closeDialogClose" @success="dialogCloseSuccess"></dialog-close>
		<dialog-product :show="showDialogProduct" :event_id="event_id" @close="closeDialogProduct"></dialog-product>
		
	</div>
	
	
</template>

<script>
	import {
		getList
	} from '@/api/event';
	import dialogDelete from '@/components/promotion/dialog-delete.vue';
	import dialogClose from '@/components/promotion/dialog-close.vue';
	import dialogProduct from '@/components/promotion/dialog-product.vue';
	export default {
		data() {
			return {
				loading: false,
				count: 0,
				list: [],
				pageSize: 10,
				currentPage: 1,
				showDialogDetele: false, // 是否显示删除弹框
				showDialogClose: false, // 是否显示强制结束弹框
				showDialogProduct: false, // 是否显示产品列表
				oper_index: 0, // 当前操作的行下标
				event_id: 0, // 当前操作的活动ID
				tipShow:true, // 顶部提示语是否显示
			}
		},
		components: {
			dialogDelete,
			dialogClose,
			dialogProduct
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				localStorage.setItem('keypage', '')
			}
			this.getList();
		},
		methods: {
			// 缓存跳转页面时需要用的信息
			cachePageinfo(){
				localStorage.setItem('keypage', this.currentPage)
			},
			// 团购建品
			gopublish(){
				this.cachePageinfo();
				this.$router.push({
					path: '/promotion/local-add',
					query: {
					}
				});
			},
			
			// 查看数据
			godata(index = 0){
				this.cachePageinfo();
				let event_id = this.list[index].id;
				this.$router.push({
					path: '/promotion/local-data',
					query: {
						event_id: event_id
					}
				});
			},
			
			// 获取页面信息
			getList() {
				this.loading = true;
				getList({
					page: this.currentPage,
					count: this.pageSize,
					type:2
				}).then(res => {
					if (res.code == 0) {
						this.count = res.data.allcount;
						this.list = res.data.list;
					} else {
						this.$message.error(res.message);
					}
					this.loading = false;
				})
			},
			// 增加表格内的索引
			tableRowClassName({row, rowIndex}) {
				//把每一行的索引放进row
				row.index = rowIndex;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			
			// 删除
			del(index = 0){
				this.oper_index = index;
				this.event_id = this.list[index].id;
				this.showDialogDetele = true;
			},
			// 关闭删除框
			closeDialogDetele() {
				this.showDialogDetele = false;
			},
			// 确认删除成功
			dialogDeteleSuccess() {
				this.showDialogDetele = false;
				// 将数组从页面中删除
				this.list.splice(this.oper_index,1);
				// -- 此段代码为了保证当前页面数据都全部删除时，可以获取前一个页面内容
				if(this.list.length == 0){
					this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : 1;
				}
				this.getList();
			},
			
			
			// 强制结束
			close(index = 0){
				this.oper_index = index;
				this.event_id = this.list[index].id;
				this.showDialogClose = true;
			},
			// 关闭强制结束框
			closeDialogClose() {
				this.showDialogClose = false;
			},
			// 确认强制结束成功
			dialogCloseSuccess() {
				this.showDialogClose = false;
				this.getList();
			},
			
			// 打开产品列表
			showProduct(index = 0){
				this.oper_index = index;
				this.event_id = this.list[index].id;
				this.showDialogProduct = true;
			},
			// 关闭产品列表
			closeDialogProduct() {
				this.event_id = 0;
				this.showDialogProduct = false;
			},
			
			// 编辑
			edit(index = 0){
				this.cachePageinfo();
				let event_id = this.list[index].id;
				this.$router.push({
					path: '/promotion/local-add',
					query: {
						event_id: event_id
					}
				});
			},
			// 关闭提示语
			close_tip(){
				this.tipShow = false;
			},
		}
	}
</script>

<style scoped="scoped">
	.page-body {
		padding: 10px 10px 30px 10px;
		background: #FFFFFF;
	}
	.btn-box{
		padding: 16px 0 30px 10px;
	}
	._tip{
		height: 40px;
		line-height: 40px;
		background-color: #F2F2F2;
		border-radius: 4px;
		padding: 0 16px;
		color: #666666;
		font-size: 12px;
	}
	.tip_close{
		font-size: 20px;
		color: #999999;
		margin-top: 10px;
		float: right;
		cursor: pointer;
	}
</style>
